import {
  CONVERSATION_FACTS_DIMENSIONS,
  CONVERSATION_FACTS_MEASURES,
  CONVERSATION_FACTS_ZONE_DIMENSIONS,
  DRIFT_APP_USER_LAST_IN_CONVERSATION,
  DRIFT_CHAT_APP_USERS_ONLY_FIRST_ROUTED_USER_DIMENSIONS,
  DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS,
  DRIFT_CHAT_END_USERS_DIMENSIONS,
  DRIFT_CHAT_PLAYBOOK_DIMENSIONS,
  DRIFT_CHAT_TAGS_MEASURES,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const RoutingSankeyExportDrilldownBase: CubeQuery = {
  name: 'RoutingSankeyExportDrilldownBase',
  query: {
    measures: [DRIFT_CHAT_TAGS_MEASURES.NAME_ROLLUP],
    dimensions: [
      CONVERSATION_FACTS_MEASURES.CONVERSATION_ID,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_APP_URL,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_STATUS,
      CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_CLOSE_AT,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.INITIAL_ROUTED_IN_USERID,
      CONVERSATION_FACTS_DIMENSIONS.END_USER_ID,
      DRIFT_CHAT_END_USERS_DIMENSIONS.EMAIL,
      DRIFT_CHAT_END_USERS_DIMENSIONS.GEO_REGION,
      DRIFT_CHAT_END_USERS_DIMENSIONS.COUNTRY_CODE,
      CONVERSATION_FACTS_DIMENSIONS.AGENT_FIRST_REPSONSE_TIME,
      CONVERSATION_FACTS_DIMENSIONS.PLAYBOOK_ID,
      CONVERSATION_FACTS_DIMENSIONS.CQL_SCORE,
      CONVERSATION_FACTS_DIMENSIONS.LAST_CLASSIFICATION_ID,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_CREATED_FROM_URL,
      DRIFT_CHAT_APP_USERS_ONLY_FIRST_ROUTED_USER_DIMENSIONS.DISPLAY_NAME,
      CONVERSATION_FACTS_DIMENSIONS.PARTICIPANT_STATUS,
      DRIFT_CHAT_PLAYBOOK_DIMENSIONS.PLAYBOOK_NAME,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.IS_DEAD_END,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_CALENDAR_DROP,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_TICKET_CREATED,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_TEAMMATE_ROUTED_IN,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_TEAMMATE_RESPONDED,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_ROUTED_AND_SOMEONE_RESPONDED_WITHIN_60S,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.ROUTING_OUTCOME,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.TIME_TO_FIRST_RESPONSE_FORMATTED,
      CONVERSATION_FACTS_DIMENSIONS.END_USER_LAST_RESPONSE_TIME,
      CONVERSATION_FACTS_DIMENSIONS.AGENT_LAST_RESPONSE_TIME,
      CONVERSATION_FACTS_DIMENSIONS.FIRST_CONVERSATION_CLOSE_TYPE,
      DRIFT_APP_USER_LAST_IN_CONVERSATION.USER_ID,
      DRIFT_APP_USER_LAST_IN_CONVERSATION.DISPLAY_NAME,
    ],
    order: [
      [CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT, 'desc'],
    ],
  },
  queryName: 'RoutingSankeyExportDrilldownBase',
}
